import {lazy} from 'react';

export const OffersListLazy = lazy(() => import(/* webpackChunkName: "offersList" */ '.'));
